import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Apollo} from "apollo-angular";
import {GET_NOTIFICATIONS, NotificationModel, UNREAD_NOTIFICATION} from "./notifications";
import {Router} from "@angular/router";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {

  notifications: NotificationModel[];

  tabs: { name: string; value: any }[] = [
    {name: 'All', value: null},
    {name: 'Unread', value: false},
    {name: 'Read', value: true}
  ]

  activeTab: boolean | null = null

  currentPage: any


  constructor(
    @Inject(MAT_DIALOG_DATA) data: { notifications: NotificationModel[], page: any },
    private dialogRef: MatDialogRef<NotificationsComponent>,
    private apollo: Apollo,
    private router: Router
  ) {
    this.notifications = data?.notifications
    this.currentPage = data?.page
  }

  closeModal(reload = false) {
    this.dialogRef.close(reload);
  }

  loadData(pageNumber: number = 1) {
    this.apollo
      .query({
        query: GET_NOTIFICATIONS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            pageNumber,
            itemsPerPage: 5,
            isRead: this.activeTab
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getNotifications;
        if (result?.response.status) {
          this.notifications = result?.data
          this.currentPage = result?.page
        }
      });
  }

  openNotification(notification: NotificationModel) {

    this.apollo
      .mutate({
        mutation: UNREAD_NOTIFICATION,
        fetchPolicy: 'network-only',
        variables: {
          input: {
            uniqueIds: [ notification?.uniqueId ]
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.unreadNotificationMutation;
        if (result?.response.status) {
          this.dialogRef.close(true);
          switch (notification?.notificationType) {
            case 'SERVICE_APPROVAL_REQUEST':
              this.router.navigateByUrl(`/service-management/service-list/${notification?.callbackItemId}`);
              break
            case 'SERVICE_CHANGE_REQUEST':
              this.router.navigateByUrl(`/service-management/service-change-requests`);
              break
          }
        }
      });

  }

  changeTab(value: boolean | null) {
    this.activeTab = value;
    this.loadData()
  }

  clearAll() {
    this.apollo
      .mutate({
        mutation: UNREAD_NOTIFICATION,
        fetchPolicy: 'network-only',
        variables: {
          input: {
            unreadAll: true
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data || {})[0];
        result = result?.unreadNotificationMutation;
        if (result?.response?.status) {
          this.notifications = [];
          this.currentPage = null;
        }
      });
  }

}
